import React, { useMemo } from 'react'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import config from 'constants/config'
import Image from 'components/Common/Image'
import FormatCurrency from 'components/Common/FormatCurrency'
import { rem } from 'polished'
import styled from 'styled-components'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import * as Analytics from 'analytics/analytics'
import { fareTypeLabelMap } from 'constants/flight'

const AIRLINE_LOGO = {
  'Malaysia Airlines': 'flight-deals-malaysia-airlines',
  'Virgin Australia': 'flight-deals-virgin-australia',
  Qantas: 'flight-deals-qantas',
  Jetstar: 'flight-deals-jetstar',
  default: 'flight-deals-default',
  emirates: 'flight-deals-emirates',
  etihad: 'flight-deals-etihad',
  qatar: 'flight-deals-qatar',
}

const StyledImage = styled(Image)`
  margin-top: ${rem(14)};
`

const InlineDefaultColourText = styled.span`
  color: ${props => props.theme.palette.neutral.default.one};
`

interface Props {
  flightDeal: App.FlightDeal;
}

function HotelSearchFlightsDeal({ flightDeal }: Props) {
  const logo = AIRLINE_LOGO[flightDeal?.carrier.name] ?? AIRLINE_LOGO.default

  const trackViewAllClick = async() => {
    await Analytics.trackClientEvent({
      subject: 'View Offer',
      action: 'They clicked “view offer” link',
      category: 'search-flight-deal-banner',
      type: 'interaction',
      optimizelyEventId: '28751360219',
      optimizelyEventKey: 'click-search-flight-deal',
    })
  }

  const fareType = useMemo(() => {
    const label = fareTypeLabelMap[flightDeal.fareType]
    return label ? `${label} flights` : 'Flights'
  }, [flightDeal.fareType])

  if (!flightDeal) {
    return null
  }
  return (
    <MessageBanner
      kind="promotional-primary"
      description={`Save on select flights with ${flightDeal.carrier.name}. Don't miss out! Sale ends soon.` }
      heading={<BodyTextBlock colour="urgency" startIcon={<SolidFireIcon size="XS" />} variant="medium">
        Limited time flight deal.{' '}
        <InlineDefaultColourText>
          {fareType} to {flightDeal.destinationName} {flightDeal.fareClass !== 'economy' ? `${flightDeal.fareClass} class` : ''} from <FormatCurrency value={flightDeal.perAdultPrice} />* per person
        </InlineDefaultColourText>
      </BodyTextBlock>}
      primaryActionButtonProps={{
        to: `/flight/deal/${flightDeal.id}`,
        target: config.OPEN_NEW_TAB_OFFER_CLICK ? '_blank' : undefined,
        children: 'View offer',
        onClick: trackViewAllClick,
      }}
      icon={<StyledImage
        id={logo}
        height={40}
      />}
    />
  )
}

export default HotelSearchFlightsDeal
